import HttpCache from './HttpCache'
import buildURL from 'axios/lib/helpers/buildURL'
import lodash from 'lodash'
/**
 * Decorate Default XHR adaptor to open and close client side http cache in run time.
 *
 */
export default function axiosCacheDecorator (adaptor) {
  const cache = HttpCache

  return config => {
    const { url, method, params, paramsSerializer } = config
    if (!lodash.get(params, 'noCache')) {
      const key = buildSortedUrl(url, params, paramsSerializer)
      const useCache = cache.shouldCache(key)
      if (useCache && method === 'get') {
        let responsePromise = cache.get(key)
        if (!responsePromise) {
          responsePromise = (async () => {
            try {
              return await adaptor(config)
            } catch (err) {
              cache.remove(key)
              throw err
            }
          })()
          cache.set(key, responsePromise)
        }
        return responsePromise
      }
    }

    return adaptor(config)
  }
}

function buildSortedUrl (...args) {
  const builtURL = buildURL(...args)

  const [urlPath, queryString] = builtURL.split('?')

  if (queryString) {
    const paramsPair = queryString.split('&')
    return `${urlPath}?${paramsPair.sort().join('&')}`
  }
  return builtURL
}
